import combineReducer from "./combine";
import auth from "./auth";
const reducer = combineReducer({
  auth,
});

export default reducer;
